import React from "react";
import { Form, Input, Space } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import CustomButton from "../../commonComponents/button";
import { checkAccessPermission } from "../../../library/helpers";
import { AccessPermissionAction } from "../../../library/constants";

const SecurityTab = ({ passwordForm, onFinish, saving }) => {
  const canEditPassword = checkAccessPermission(AccessPermissionAction.USER_PROFILE_USER_PASSWORD);

  return (
    <div className="pt-8 px-4">
      <p className="text-black-88 font-semibold text-base mb-6">Change Password</p>

      <Form
        form={passwordForm}
        layout="vertical"
        onFinish={onFinish}
        disabled={!canEditPassword}
        className="w-full sm:max-w-[360px]"
      >
        <Form.Item
          className="mb-6"
          name="currentPassword"
          label={<span className="form-field-label">Current password</span>}
          rules={[{ required: true, message: "Please enter current password" }]}
        >
          <Input.Password
            placeholder="Enter current password"
            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item
          className="mb-6"
          name="newPassword"
          label={<span className="form-field-label">New password</span>}
          rules={[
            { required: true, message: "Please enter new password" },
            { min: 8, message: "Password must be at least 8 characters" },
          ]}
        >
          <Input.Password
            placeholder="Enter new password"
            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Form.Item
          className="mb-6"
          name="confirmPassword"
          label={<span className="form-field-label">Confirm new password</span>}
          dependencies={["newPassword"]}
          rules={[
            { required: true, message: "Please confirm new password" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue("newPassword") === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error("Passwords do not match"));
              },
            }),
          ]}
        >
          <Input.Password
            placeholder="Confirm new password"
            iconRender={visible => (visible ? <EyeOutlined /> : <EyeInvisibleOutlined />)}
          />
        </Form.Item>

        <Space className="mt-2">
          <CustomButton
            type="primary"
            htmlType="submit"
            disabled={!canEditPassword}
            loading={saving}
            btnText="Save"
          />
          <CustomButton
            htmlType="button"
            handleClick={() => passwordForm.resetFields()}
            btnText="Cancel"
          />
        </Space>
      </Form>
    </div>
  );
};

export default SecurityTab;
